import { Box, Typography, useTheme } from "@mui/material";

import { RecentProjectsTable } from "Dashboard/Components/RecentProjectsTable";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

export const RecentProjects = (): React.ReactNode => {
  const theme = useTheme();
  const { t } = useResource();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: 1,
          marginBottom: theme.spacing(Spacing.M),
          color: theme.palette.text.primary,
        }}
      >
        {t(Resources.Dashboard.RecentProjects)}
      </Typography>
      <RecentProjectsTable />
    </Box>
  );
};
